import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/index';

export interface ModalState {
  data: any;
  title: string;
  actionsGroup: any;
  stackedModal: ModalState[];
  loading?: boolean;
  setDataModal?: any;
}

const initialState: ModalState = {
  data: null,
  title: '',
  actionsGroup: null,
  stackedModal: [],
  loading: false,
  setDataModal: null
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setDataModal: (state: ModalState, action: PayloadAction<any>) => {
      state.stackedModal = [...state.stackedModal, {
        data: state.data,
        title: state.title || '',
        actionsGroup: state.actionsGroup,
        stackedModal: state.stackedModal
      }];
      state.data = action.payload;
    },
    setTitleModal: (state: ModalState, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setActionsGroupModal: (state: ModalState, action: PayloadAction<any>) => {
      state.actionsGroup = action.payload;
    },
    resetModal: (state: ModalState) => {
      let previousState = null;
      if (state.stackedModal.length > 0) previousState = state.stackedModal.pop();

      state.data = previousState?.data || null;
      state.title = previousState?.title || '';
      state.actionsGroup = previousState?.actionsGroup || null;
      state.stackedModal = previousState?.stackedModal || [];
    },
    setLoadingModal: (state: ModalState, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    }
  }
});

export const {
  setDataModal,
  setTitleModal,
  setLoadingModal,
  resetModal
} = modalSlice.actions;

export const modalReducer = (state: RootState) => state.modal;

export const ModalReducer = modalSlice.reducer;
